function n(value) {
  return Number(value || 0) || 0;
}

function pct(value) {
  return `${n(value).toFixed(1)}%`;
}

function money(value) {
  return `GBP ${n(value).toFixed(2)}`;
}

function sortEngineers(engineers) {
  return [...(engineers || [])].sort((a, b) => {
    const byCommission = n(b.commission) - n(a.commission);
    if (byCommission) return byCommission;
    return n(b.totalParts) - n(a.totalParts);
  });
}

export function buildHistoryOperationalBrief(metrics, options = {}) {
  if (!metrics || n(metrics.totalParts) <= 0) return [];

  const maxItems = Math.max(1, n(options.maxItems || 4));
  const totalParts = n(metrics.totalParts);
  const timestampCoverage = totalParts
    ? (n(metrics.datedRecords) / totalParts) * 100
    : 0;
  const berRate = totalParts ? (n(metrics.berParts) / totalParts) * 100 : 0;
  const engineerCount = (metrics.engineers || []).length;
  const items = [];

  if (n(options.ungradedCount) > 0) {
    items.push({
      id: "ungraded-cleanup",
      tone: "warning",
      title: "Grade reference cleanup",
      value: `${n(options.ungradedCount).toLocaleString()} parts`,
      detail: "Ungraded completed parts hide the true commission mix.",
      action: "Fix the most common ungraded parts before the next upload.",
    });
  }

  if (timestampCoverage < 75) {
    items.push({
      id: "timestamp-coverage",
      tone: "warning",
      title: "Timestamp coverage",
      value: pct(timestampCoverage),
      detail: "Daily and hourly workload patterns are incomplete.",
      action: "Prefer newer KPI exports with completed timestamps.",
    });
  }

  if (n(options.summaryRecordGap) > 0) {
    items.push({
      id: "summary-detail-gap",
      tone: "risk",
      title: "Summary/detail gap",
      value: n(options.summaryRecordGap).toLocaleString(),
      detail: "Saved summary totals do not fully match detailed part rows.",
      action: "Re-save the affected period after confirming the source export.",
    });
  }

  if (berRate >= 20) {
    items.push({
      id: "ber-pressure",
      tone: "risk",
      title: "BER pressure",
      value: pct(berRate),
      detail: "A high BER share can drag effective repair earnings down.",
      action: "Check whether BER-heavy stock needs routing or expectation changes.",
    });
  }

  if (engineerCount > 0 && n(metrics.rotaCoverage) < engineerCount) {
    const missing = engineerCount - n(metrics.rotaCoverage);
    items.push({
      id: "rota-coverage",
      tone: "warning",
      title: "Rota coverage gap",
      value: `${missing.toLocaleString()} missing`,
      detail: "Some engineers have History rows without a rota match.",
      action: "Update aliases or rota data so daily averages use real workdays.",
    });
  }

  const leader = sortEngineers(metrics.engineers)[0];
  if (leader) {
    items.push({
      id: "throughput-leader",
      tone: "good",
      title: "Throughput leader",
      value: leader.engineer || "Unknown",
      detail: `${n(leader.totalParts).toLocaleString()} parts, ${money(leader.commission)} commission`,
      action: "Use this as the benchmark for the selected period.",
    });
  }

  return items.slice(0, maxItems);
}
